// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/weight-balance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/weight-balance/avgas-weight.js';
import g1 from '../lessons/aeronautics/weight-balance/weight-balance-terms.js';
import g2 from '../lessons/aeronautics/weight-balance/weight-balance.js';

mount([g0, g1, g2]);
